
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function ReusableStringIndex() {
  return (
    <NonFSIndex
      data_type="reusable_string"
      // save_all
    />
  );
}
